<template>
  <div>
    <md-button
      v-if="$store.state.player.isStarted"
      @click="capture"
      class="md-info"
      >take a snapshot</md-button
    >
    <div id="storesnapshot" class="row md-card-body"></div>
  </div>
</template>

<script>
export default {
  name: "snapshot-widget",
  props: [],
  mixins: [],
  components: {},
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    capture() {
      // create canvas
      var canvas = document.createElement("canvas");
      // add different id for each snapshot
      canvas.id = `snapshot${Math.random()}`;
      //add styles
      canvas.classList.add("col-6");
      canvas.classList.add("col-md-4");
      //add container for all snapshots
      var div = document.getElementById("storesnapshot");
      div.appendChild(canvas);
      // HTML element of videojs as class 'vjs-tech' , capture this class to get videoHTML for canvas:
      var video = document.getElementsByClassName("vjs-tech")[0];
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      // capture image from video
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      const playImage = new Image();
      playImage.src = "path to image asset";
      playImage.onload = () => {
        const startX = video.videoWidth / 2 - playImage.width / 2;
        const startY = video.videoHeight / 2 - playImage.height / 2;
        canvas
          .getContext("2d")
          .drawImage(
            playImage,
            startX,
            startY,
            playImage.width,
            playImage.height
          );
      };
    },
  },
};
</script>
